import {
	DadosGraficoVariaveis,
	DadosSerieVariavelMeteorologica,
	SerieVariavelMeteorologica,
} from './serie-variavel-meteorologica';
import mensagens from './mensagens';
import { getOptions } from 'highcharts';

export interface DadosUmidade extends DadosGraficoVariaveis {
	umidade: number[];
}

export class SerieUmidade extends SerieVariavelMeteorologica {
	private corUmidade = getOptions().colors?.at(2);

	constructor(readonly nomeDaSerie?: string) {
		super();
	}

	obterDadosSerie(
		dados: DadosUmidade,
		indexEixo: number
	): DadosSerieVariavelMeteorologica {
		if (this.corUmidade) {
			return {
				serie: [
					{
						yAxis: indexEixo,
						name: this.nomeDaSerie
							? this.nomeDaSerie
							: mensagens['variavel.umidade'],
						type: 'line',
						data: this.prepararSerie(dados.datas, dados.umidade),
						color: this.corUmidade,
						tooltip: {
							valueDecimals: 2,
							valueSuffix: ` ${mensagens['variavel.umidade.unidade']}`,
						},
					},
				],
				eixo: {
					title: {
						text: this.nomeDaSerie
							? this.adicionarUnidade(this.nomeDaSerie)
							: mensagens['variavel.umidade.titulo-meteograma'],
					},
					lineWidth: 2,
					opposite: false,
					labels: { align: 'left', x: 3 },
					min: 0,
					softMax: 110,
				},
			};
		}
		return { eixo: {}, serie: [] };
	}

	private adicionarUnidade(nomeDaSerie: string): string {
		return nomeDaSerie + ` ( ${mensagens['variavel.umidade.unidade']} )`;
	}
}
